import { RestaurantTypes } from '../enums/restaurant-type';

export class RestaurantTypeNames {
  public name: string;
  public value: number;
}

export const RestaurantsType: RestaurantTypeNames[] = [
  {
    name: 'Jade Restaurant',
    value: RestaurantTypes.RESTAURANT
  },
  {
    name: 'Jade Teriyaki',
    value: RestaurantTypes.TERIYAKI
  },
  {
    name: 'Tamashi',
    value: RestaurantTypes.TAMASHI
  },
  {
    name: 'Zen Kitchen',
    value: RestaurantTypes.ZENKITCHEN
  }
];
